import { DumpsterSize, Pricing } from "../../../models";

// Wire shape of the `pricing` setting value. Money is serialized by the
// backend's shopspring/decimal as JSON strings (e.g. "425", "0.045").
export interface RawPricing {
  dumpster_rental_by_size: Record<string, string>;
  overweight_per_pound: string;
}

export function getPricing(raw: RawPricing): Pricing {
  const bySize = raw.dumpster_rental_by_size;
  return {
    dumpsterRentalBySize: {
      [DumpsterSize.SIZE_10]: parseFloat(bySize[DumpsterSize.SIZE_10]),
      [DumpsterSize.SIZE_15]: parseFloat(bySize[DumpsterSize.SIZE_15]),
      [DumpsterSize.SIZE_CLEAN_FILL]: parseFloat(bySize[DumpsterSize.SIZE_CLEAN_FILL]),
    } as Record<DumpsterSize, number>,
    overweightPerPound: parseFloat(raw.overweight_per_pound),
  };
}
